import { render, staticRenderFns } from "./furnitureshop-specification.vue?vue&type=template&id=30c7e16a&scoped=true&"
import script from "./furnitureshop-specification.vue?vue&type=script&lang=js&"
export * from "./furnitureshop-specification.vue?vue&type=script&lang=js&"
import style0 from "./furnitureshop-specification.vue?vue&type=style&index=0&id=30c7e16a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c7e16a",
  null
  
)

export default component.exports